export default __webpack_public_path__ + "static/media/QuikVentory.eaa44ea7.mp4";